import { useState } from "react";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import { getCategoryIcon, getJobTemplateIcon } from "../../../../utils/getMaterialJobIcons";
import "./ActivityFlow.css";

const FlowSidebar = ({ smJobs, onJobDragStart, onCustomNodeDragStart }) => {
  const [activeTab, setActiveTab] = useState("PA Jobs");

  // Custom nodes configuration
  const customNodes = [
    {
      id: "if_else",
      name: "If-Else",
      icon: "alt_route"
    },
    {
      id: "if_else_if",
      name: "If-Else-If",
      icon: "device_hub"
    },
    {
      id: "switch",
      name: "Switch",
      icon: "call_split"
    },
    {
      id: "transform",
      name: "Transform",
      icon: "transform"
    },
    {
      id: "merge",
      name: "Merge",
      icon: "merge"
    },
    {
      id: "distribute",
      name: "Distribute",
      icon: "share"
    }
  ];

  // Group jobs by category
  const groupedJobs = smJobs.reduce((acc, job) => {
    const category = job.category;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(job);
    return acc;
  }, {});

  return (
    <div className="activity_flow_sidebar">
      {/* Sidebar Tabs */}
      <div className="flow_sidebar_tabs">
        <button
          className={`flow_sidebar_tab ${activeTab === "PA Jobs" ? "active" : ""}`}
          onClick={() => setActiveTab("PA Jobs")}
        >
          PA Job Nodes
        </button>
        <button
          className={`flow_sidebar_tab ${activeTab === "Custom Nodes" ? "active" : ""}`}
          onClick={() => setActiveTab("Custom Nodes")}
        >
          Custom Nodes
        </button>
      </div>

      <div className="flow_sidebar_content">
        {/* PA Jobs Tab Content */}
        {activeTab === "PA Jobs" && (
          <>
            {Object.entries(groupedJobs).map(([category, jobs]) => (
              <div key={category} className="flow_sidebar_section">
                <div className="flow_sidebar_header">
                  <MaterialIcon name={getCategoryIcon(category)} className="flow_header_icon" />
                  <span className="flow_header_title">{category}</span>
                </div>
                <div className="flow_sidebar_grid">
                  {jobs.map((job) => (
                    <div key={job.id} className="flow_job_card" draggable onDragStart={(e) => onJobDragStart(e, job)}>
                      <div className="flow_job_icon">
                        <MaterialIcon
                          name={getJobTemplateIcon(job.job_template)}
                          style={{ fontSize: "32px", color: "#5f6368" }}
                        />
                      </div>
                      <div className="flow_job_name">{job.name}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </>
        )}

        {/* Custom Nodes Tab Content */}
        {activeTab === "Custom Nodes" && (
          <div className="flow_sidebar_grid">
            {customNodes.map((node) => (
              <div
                key={node.id}
                className="flow_job_card"
                draggable
                onDragStart={(e) => onCustomNodeDragStart(e, node)}
              >
                <div className="flow_job_icon">
                  <MaterialIcon name={node.icon} style={{ fontSize: "32px", color: "#5f6368" }} />
                </div>
                <div className="flow_job_name">{node.name}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FlowSidebar;
